export const SELECTION_CONTROLLER = 'selection_controller'
export const IMAGE_UPLOAD = 'image_upload'
export const COLOR_PICKER = 'color_picker'
export const STYLES_COLOR_PICKER = 'styles_color_picker'
export const LEAN_CONTROLLER = 'lean_controller'
export const BOUNDARY_CONTROLLER = 'boundary_controller'
export const INPUT_HANDLER = 'input_handler'
export const SELECT = 'select'
export const SELECT_MULTI = 'select_multi'